import { render, staticRenderFns } from "./RegisterClientForm.vue?vue&type=template&id=65211b9a&scoped=true&"
import script from "./RegisterClientForm.vue?vue&type=script&lang=js&"
export * from "./RegisterClientForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClientForm.vue?vue&type=style&index=0&id=65211b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65211b9a",
  null
  
)

export default component.exports